import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer-bar" role="contentinfo">
      <div className="footer-inner">
        <span className="footer-copy">© {year} Partner Panel</span>
        <nav className="footer-links" aria-label="Юридическая информация">
          <a href="/privacy-policy">Политика</a>
          <a href="/public-agreement">Договор</a>
        </nav>
      </div>
    </footer>
  );
}
